/**
 * Fetches files the person is likely to need next (a sample, an example video) at a
 * low priority, so the browser cache has them by the time ▶ is pressed. Each link
 * once per session; a failure is silent — the real request will try again.
 */
const warmed = new Set<string>();

export function warmUp(urls: ReadonlyArray<string | null | undefined>, fetchImpl: typeof fetch = fetch): number {
  let started = 0;
  for (const url of urls) {
    if (!url || warmed.has(url)) continue;
    warmed.add(url);
    started++;
    void fetchImpl(url, { priority: 'low' } as RequestInit).catch(() => warmed.delete(url));
  }
  return started;
}

/** Tests only. */
export function forgetWarmed(): void {
  warmed.clear();
}
